import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import WishlistInner from '../Components/Shop/WishlistInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Wishlist() {
    return (
        <>
            <SEO 
                title="Wishlist - Tourm Travel Shop"
                description="View your saved wishlist items."
                url="/wishlist"
            />
            <HeaderOne />
            <Breadcrumb
                title="Wishlist"
            />
            <WishlistInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Wishlist
